import { Divider, Stack } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CustomButton, { CustomButtonProps } from './CustomButton';

export type LinkedInLoginButtonProps = Omit<
  CustomButtonProps,
  'variant' | 'withBackArrow' | 'withNextArrow'
>;

const LinkedInLoginButton = ({ children, ...props }: LinkedInLoginButtonProps) => (
  <CustomButton
    sx={{
      width: 'fit-content',
      backgroundColor: '#0077B5',
      ':hover': { backgroundColor: '#0077B5', borderColor: '00a3f8' },
      border: '3px solid',
      borderColor: '#0077B5',
      textTransform: 'none',
      pl: '8px',
      fontSize: '18px',
    }}
    variant="primary"
    startIcon={
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <LinkedInIcon sx={{ width: '40px', height: '40px' }} />
        <Divider orientation="vertical" />
      </Stack>
    }
    {...props}
  >
    {children}
  </CustomButton>
);

export default LinkedInLoginButton;
